import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import { View } from 'react-native';
import BarGraphWrapper from './BarGraphWrapper';
import { Typography } from '@hmsexp/component-library';
import { handleHighChartsExport } from '../../utils';
import { useWindowDimensions } from 'react-native';
import { ScrollView } from '../../../../components/Common/react-native-components';

const AlertsSummaryGraph = forwardRef(({ data }, ref) => {
  const { width } = useWindowDimensions();
  const isMobile = width < 768;

  const barGraphRef = useRef(null);

  const totalNew = data?.total_new;
  const totalInProgress = data?.total_in_progress;
  const totalOverdue = data?.total_overdue;
  const totalClosed = data?.total_closed;
  const totalAll = data?.total_total;
  const totalOpen = data?.total_open;

  const actionButtonClick = async e => {
    await handleHighChartsExport(e, barGraphRef, data);
  };

  useImperativeHandle(ref, () => ({ actionButtonClick }), []);

  const metrics = [
    { label: 'Total Open Alerts', value: totalOpen },
    { label: 'Total Closed Alerts', value: totalClosed },
    { label: 'Total Alerts', value: totalAll }
  ];

  const containerStyle = {
    backgroundColor: '#fff',
    padding: isMobile ? 12 : 20,
    borderRadius: 12,
    margin: isMobile ? 5 : 10
  };

  const leftPanelStyle = {
    width: isMobile ? '100%' : '15%',
    paddingRight: isMobile ? 0 : 10,
    marginBottom: isMobile ? 20 : 0,
    justifyContent: 'center'
  };

  return (
    <View style={containerStyle}>
      <View
        style={{
          flexDirection: isMobile ? 'column' : 'row',
          width: '100%',
          marginTop: isMobile ? 10 : 30
        }}>
        <View style={leftPanelStyle}>
          {metrics.map((item, idx) => (
            <View key={idx}>
              <Typography variant={isMobile ? 'body2' : 'body1'}>{item.label}</Typography>

              <Typography variant={isMobile ? 'h5' : 'h4'}>{item.value}</Typography>

              {idx < metrics.length - 1 && (
                <View
                  style={{
                    height: 1,
                    backgroundColor: '#E6E6E6',
                    marginVertical: 6
                  }}
                />
              )}
            </View>
          ))}
        </View>

        <ScrollView
          horizontal={isMobile}
          showsHorizontalScrollIndicator={false}
          contentContainerStyle={{ flexGrow: 1, justifyContent: 'center' }}
          style={{ width: isMobile ? '100%' : '85%' }}>
          <View style={{ width: isMobile ? 600 : '100%' }}>
            <BarGraphWrapper
              ref={barGraphRef}
              newCount={Number(totalNew) || 0}
              inProgress={Number(totalInProgress) || 0}
              overdue={Number(totalOverdue) || 0}
              closed={Number(totalClosed) || 0}
            />
          </View>
        </ScrollView>
      </View>
    </View>
  );
});

export default AlertsSummaryGraph;